import { useRef, useEffect } from 'react';

import Modal from './modal';

import './styles.css';

import Logo from './images/logo.jpg';

export const Step4 = ({onNext}) => {
  return (
    <Modal className="step-4">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h4>Market Games</h4>
      <p>Ready to <b>Master the Basics?</b></p>
      <button className="button onboarding-big-button student-onboarding-big-button" onClick={onNext}>Let's Go!</button>
    </Modal>
  )
};